import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useCategories from "../hooks/useCategories";

const CATEGORY_IDS = [
  "69da225ee1bb8f618a8b4499",
  "66bfdfecfd7bc72b9f5dc3f7",
  "66bfdfecfd7bc72b9f5dc3fb",
  "67f75f938a6465b2abec8aa0",
  "687499851b092c464d1bb35a",
];

const FooterCategory = () => {
  const { i18n } = useTranslation();

  const {
    data: categories = [],
    isLoading,
    error,
  } = useCategories(`?ids=${CATEGORY_IDS.join(",")}`);

  if (isLoading || error || !categories.length) return null;

  const orderedCategories = CATEGORY_IDS.map((id) =>
    categories.find((category) => category._id === id),
  ).filter(Boolean);

  return (
    <ul className="mt-6 space-y-4">
      {orderedCategories.map((category) => {
        const name =
          category?.name?.[i18n.language] ||
          category?.name?.en ||
          category?.name?.da ||
          category?.name?.pa ||
          "";

        return (
          <li key={category._id}>
            <Link
              to={`/category/${category._id}`}
              className="text-sm leading-6 text-gray-300 hover:text-white"
            >
              {name}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default FooterCategory;
